import { atom } from 'recoil'
import { persistAtom } from '../persist'

export type TAuthAtomState = {
  businessId: null | string
  username: null | string
}
// 不要なら削除
export type TAuthTokenAtomState =
  | undefined
  | {
      refresh: string
      access: string
    }

export const initAuthState: TAuthAtomState = {
  businessId: null,
  username: null,
}

export const authState = atom<TAuthAtomState>({
  key: 'authState',
  default: initAuthState,
  effects_UNSTABLE: [persistAtom],
})
